export default "__VITE_ASSET__784031e9__"